<template>
  <div class="mx-auto container container--fluid">

    <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar dense class="toolbar" flat color="white">
        <v-toolbar-title>Subject Catalogue</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>

      <div class="masters-page">
        <div v-if="subjects_list.length === 0" class="empty-state">
          <v-icon size="64" color="#b0bec5">mdi-book-open-outline</v-icon>
          <p class="empty-text">No Subjects Found</p>
        </div>

        <div v-else class="masters-grid">
          <div
            v-for="(subject, index) in subjects_list"
            :key="subject.id"
            class="master-card"
            :style="{ '--delay': index * 80 + 'ms' }"
            @click="selectMaster(subject)"
          >
            <img
              v-if="subject.logo_file_path"
              :src="getLogoUrl(subject.logo_file_path)"
              :alt="subject.name"
              class="subject-logo"
              @error="subject._imgFailed = true"
            />

            <div v-else class="fallback-letter">
              {{ subject.name[0].toUpperCase() }}
            </div>

            <div class="card-label">{{ subject.course_name }}</div>
          </div>
        </div>

      </div>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </div>
</template>

<script>
import axios from "axios";
const BASE_URL = process.env.VUE_APP_CONTENT_URL;
const BASE_PATH = "https://vierp-test.s3.ap-south-1.amazonaws.com/"

export default {
  data: () => ({
    overlay: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    subjects_list: [],
    learner_standard:"",
    learner_board:"",
    learner_courses:[],
    usertype:[],

  }),

  mounted() {
    this.onLoad();
  },

  methods: {
    onLoad() {
      this.overlay = true;

      this.learner_standard = sessionStorage.getItem("learner_standard")
      this.learner_board = sessionStorage.getItem("learner_board")
      this.learner_courses  = JSON.parse(sessionStorage.getItem("learner_courses"));
      this.usertype = localStorage.getItem("EPS-ut")

      const data = {
        learner_standard: this.learner_standard,
        learner_board: this.learner_board,
        learner_courses: this.learner_courses,
        usertype: this.usertype
      };

      axios.post(BASE_URL + "subjectCatalogue/getSubjectsList",data)
        .then((res) => {
          if (res.data.flag === "true") {
            this.subjects_list = res.data.subjects_list.map(s => ({
              ...s,
              _imgFailed: false
            }));
          } else {
            this.showSnackbar("red", res.data.msg);
          }
        })
        .catch(() => {
          this.showSnackbar("red", "Failed to load subjects");
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    getLogoUrl(path) {
      return `${BASE_PATH}${path}`;
    },

    selectMaster(subject) {
      sessionStorage.setItem("subject_name", subject.course_name);
      sessionStorage.setItem("subject_code", subject.course_code);
      this.$router.push({ name: "digital-learning" });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>

<style scoped>
/* Grid Styles */
.masters-page {
  padding: 28px;
}

.masters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 24px;
}

.master-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  padding: 24px 16px 20px;
  border-radius: 14px;
  border: 2px solid #c5cae9;
  animation: cardIn 0.4s ease both;
  animation-delay: var(--delay, 0ms);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.master-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

@keyframes cardIn {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

.subject-logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.fallback-letter {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #e8eaf6;
  color: #5c6bc0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: 700;
}

.card-label {
  font-size: 14px;
  font-weight: 600;
  color: #37474f;
  text-align: center;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  gap: 16px;
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #90a4ae;
}
</style>